import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import LanguageToggle from './LanguageToggle';

const EventimeHeader = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { t } = useLanguage();

  const navigation = [
    { name: t('nav.home'), href: '#hero' },
    { name: t('nav.services'), href: '#services' },
    { name: t('nav.about'), href: '#about' },
    { name: t('nav.expo'), href: '#expo' },
    { name: t('nav.events'), href: '#upcoming-events' },
    { name: t('nav.career'), href: '#career' }
  ];

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <header className={`network-header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="nav-wrapper">
        <div 
          onClick={() => handleNavClick('#hero')}
          style={{
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer',
            textDecoration: 'none'
          }}
        >
          <img 
            src="https://customer-assets.emergentagent.com/job_glassmorph-eventime/artifacts/0p3790vd_Logo-3.png"
            alt="Eventime Logo"
            style={{
              height: '50px',
              width: 'auto'
            }}
          />
        </div>
        
        {/* Desktop Navigation */}
        <nav className="network-nav">
          {navigation.map((item) => (
            <a
              key={item.name}
              href={item.href}
              className="network-nav-link"
              onClick={(e) => {
                e.preventDefault();
                handleNavClick(item.href);
              }}
            >
              {item.name}
            </a>
          ))}
          
          {/* Language Toggle */}
          <LanguageToggle />
        </nav>

        {/* Mobile Menu Button */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          {/* Mobile Language Toggle */}
          <div className="mobile-language-toggle" style={{ display: 'none' }}>
            <LanguageToggle />
          </div>
          
          <button
            className="mobile-menu-toggle"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            style={{
              display: 'none',
              background: 'transparent',
              border: 'none',
              color: 'white',
              cursor: 'pointer',
              padding: '8px'
            }}
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation Menu */}
      {isMobileMenuOpen && (
        <div 
          className="mobile-nav"
          style={{
            position: 'absolute',
            top: '100%',
            left: '12px',
            right: '12px',
            background: 'var(--brand-dark)',
            borderRadius: '0 0 25px 25px',
            padding: '16px',
            boxShadow: '0 4px 12px rgba(0, 69, 52, 0.25)'
          }}
        >
          {navigation.map((item) => (
            <a
              key={item.name}
              href={item.href}
              className="network-nav-link"
              onClick={(e) => {
                e.preventDefault();
                handleNavClick(item.href);
              }}
              style={{
                display: 'block',
                margin: '8px 0',
                textAlign: 'center'
              }}
            >
              {item.name}
            </a>
          ))}
          
          {/* Mobile Language Toggle in Menu */}
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: '16px',
            paddingTop: '16px',
            borderTop: '1px solid rgba(255, 255, 255, 0.2)'
          }}>
            <LanguageToggle />
          </div>
        </div>
      )}

      <style>{`
        @media (max-width: 781px) {
          .network-nav {
            display: none;
          }
          
          .mobile-menu-toggle {
            display: block !important;
          }
          
          .mobile-language-toggle {
            display: block !important;
          }
        }
      `}</style>
    </header>
  );
};

export default EventimeHeader;